import type { ByggKunde } from '@klp/bygg/components/ByggKunder/classes';

import type { IClient } from './IClient';

export class Client implements IClient {
    public kundeNummer: IClient['kundeNummer'];
    public kundeName: IClient['kundeName'];
    public aktive: IClient['aktive'];
    public fremtidige: IClient['fremtidige'];
    public inaktive: IClient['inaktive'];
    public isHandelKunde: IClient['isHandelKunde'];
    public isNaeringKunde: IClient['isNaeringKunde'];
    public soContactID: IClient['soContactID'];
    public isSuperOfficeKunde: IClient['isSuperOfficeKunde'];

    public static parseObject(obj: IClient): Client {
        try {
            return new Client(obj);
        } catch (error) {
            throw new Error(
                `Not able to parse Client object, object attempted to parse is: ${JSON.stringify(
                    obj,
                )}`,
            );
        }
    }

    constructor(obj: IClient) {
        if (!obj?.kundeNummer) {
            throw new Error('kundeNummer is required');
        }
        this.kundeNummer = obj.kundeNummer;
        this.kundeName = obj.kundeName?.trim() ?? '';
        this.aktive = obj.aktive ?? 0;
        this.fremtidige = obj.fremtidige ?? 0;
        this.inaktive = obj.inaktive ?? 0;
        this.isHandelKunde = obj.isHandelKunde ? obj.isHandelKunde : false;
        this.isNaeringKunde = obj.isNaeringKunde ? obj.isNaeringKunde : false;
        this.soContactID = obj.soContactID;
        this.isSuperOfficeKunde = !!obj.isSuperOfficeKunde;
    }

    public toClient = () => {
        const {
            kundeName,
            kundeNummer,
            aktive,
            inaktive,
            fremtidige,
            soContactID,
            isHandelKunde,
            isNaeringKunde,
            isSuperOfficeKunde,
        } = this;
        return {
            kundeNummer,
            kundeName,
            aktive,
            fremtidige,
            inaktive,
            soContactID,
            isHandelKunde,
            isNaeringKunde,
            isSuperOfficeKunde,
        };
    };

    public static fromByggKunde = (byggKunde: ByggKunde): Client => {
        return Client.parseObject({
            kundeNummer: byggKunde.kundeNummer,
            kundeName: byggKunde.kundeNavn,
            isSuperOfficeKunde: byggKunde.isSuperOfficeKunde,
            isHandelKunde: byggKunde.isHandelKunde,
            isNaeringKunde: byggKunde.isNaeringKunde,
        });
    };
}
